export default {
  required: 'This field is required',
  email: 'Please enter a valid email address',
  email_format: 'You must provide a valid Email Address',
  only_numbers: 'This field can be only numbers',
  password_length: 'The password must have at least 8 characters',
  before_today: 'The document must have been issued before today',
  after_today: "The document shouldn't be expired",
  positive: 'It must be a number greater than 0',
  non_negative: 'It must be a number greater or equal than 0',
  above1: 'It must be a number greater than 1',
  legal_age: 'You must be older than 18 years old in order to incorporate',
  required_email: 'You must provide an Email Address',
  required_password: 'You must provide a password',
  required_first_name: 'You must provide a First Name',
  required_last_name: 'You must provide a Last name',
  required_phone_number: 'You must provide a Phone Number',
  phone_number: 'You must provide a valid telephone number',
  bv_suffix:
    'We will add automatically "BV" at the end of the name. Therefore you do not have to fill it in',
  required_generic: 'This field is required',
  zip_code:
    'you must write exactly 4 characters a space and 2 uppercase letters',
  min_length_80: 'The description should be at least 80 words long',
  max_length_1k: 'The description should be at most 900 characters long'
};
